<!--
 * @Author: Shen Kui
 * @LastEditTime: 2023-09-26 09:21:27
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    class="p-10px absolute text-white w-468px rounded-2px sceneAnimation"
    :style="{
      height: location.height,
      top: location.top,
      right: location.float === 'right' ? '25px' : '',
      left: location.float === 'left' ? '25px' : '',
    }"
  >
    <el-row type="flex" align="middle">
      <el-col :span="12"><span class="text-14px text-white">场景动画</span></el-col>
      <el-col :span="12"
        ><span
          class="iconfont float-right cursor-pointer icon-line-close text-12px"
          @click="closeComponent"
        ></span
      ></el-col>
    </el-row>
    <div class="content mt-10px h-[calc(100%-36px)] p-10px overflow-y-auto" v-loading="listLoading">
      <el-row type="flex" align="middle">
        <el-col :span="12">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索名称"
            size="small"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button type="primary" size="small" @click="getSearchResult">搜索</el-button>
          <el-button type="primary" size="small" @click="addNode">加入</el-button>
          <el-button type="danger" size="small" @click="deleteData">删除</el-button>
        </el-col>
      </el-row>
      <div class="table-content mt-10px" :class="showAnimationDetail ? 'h-250px' : 'h-596px'">
        <el-table
          ref="nodeTable"
          :data="nodeList"
          height="100%"
          border
          @selection-change="selectionChange"
          @row-click="handleClickNode"
          row-key="id"
        >
          <el-table-column align="center" type="selection" reserve-selection> </el-table-column>
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column prop="nodeName" label="模型名称" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-10px mb-10px float-right text-white"
          small
          background
          @size-change="getSearchResult"
          @current-change="getNodeList"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.pageTotal"
        >
        </el-pagination>
      </div>
      <div class="mt-50px overflow-hidden" :class="showAnimationDetail ? 'h-340px' : 'h-0'">
        <div class="text-14px text-white">状态列表</div>
        <div class="flex justify-between h-190px mt-10px">
          <div
            class="border border-gray-400 border-solid h-full overflow-y-auto w-[calc(50%-5px)] p-10px"
          >
            <div
              class="flex justify-between items-center cursor-pointer"
              :class="{ 'text-blue-500': currentStatusSeq === item.seqNo }"
              v-for="item in nodeAnimationDetails"
              :key="item.id"
              @click="handleClickStatus(item)"
            >
              <span class="text-14px w-160px truncate">{{ item.name }}</span>
              <span class="iconfont icon-bg-tool" @click="editCurrentStatus(item)"></span>
            </div>
          </div>
          <div class="h-full overflow-y-auto w-[calc(50%-5px)]">
            <el-row class="text-14px" type="flex" align="middle">
              <el-col :span="8">循环方式</el-col>
              <el-col :span="16"
                ><el-select
                  size="small"
                  v-model="animationDetail.loopType"
                  placeholder="循环方式"
                  popper-class="document_select-popper"
                >
                  <el-option
                    v-for="item in loopTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
              ></el-col>
            </el-row>
            <el-row class="text-14px mt-15px" type="flex" align="middle">
              <el-col :span="8">循环间隔</el-col>
              <el-col :span="16"
                ><el-input
                  v-model="animationDetail.loopInterval"
                  placeholder="循环间隔"
                  size="small"
                  ><template slot="append">s</template></el-input
                ></el-col
              >
            </el-row>
            <el-row class="text-14px mt-15px" type="flex" align="middle">
              <el-col :span="8">动画速度</el-col>
              <el-col :span="16"
                ><el-input
                  v-model="animationDetail.speed"
                  placeholder="动画速度"
                  size="small"
                ></el-input
              ></el-col>
            </el-row>
            <el-row class="text-14px mt-15px" type="flex" align="middle">
              <el-col :span="8">速度曲线</el-col>
              <el-col :span="16"
                ><el-select
                  v-model="animationDetail.speedCurve"
                  placeholder="速度曲线"
                  popper-class="document_select-popper"
                >
                  <el-option
                    v-for="item in speedCurveOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
              ></el-col>
            </el-row>
          </div>
        </div>
        <el-row type="flex" align="middle" class="mt-10px">
          <el-col :span="4" class="text-14px">模型工具</el-col>
          <el-col :span="20">
            <el-tooltip effect="dark" content="移动" placement="top">
              <i
                class="iconfont icon-yxr-move text-20px mr-20px cursor-pointer"
                :class="{ 'text-blue-500': editType === 1 }"
                @click="setEditType(1)"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="旋转" placement="top">
              <i
                class="iconfont icon-yxr-rotate text-20px mr-20px cursor-pointer"
                :class="{ 'text-blue-500': editType === 2 }"
                @click="setEditType(2)"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="缩放" placement="top">
              <i
                class="iconfont icon-line-fullScreen text-20px cursor-pointer"
                :class="{ 'text-blue-500': editType === 3 }"
                @click="setEditType(3)"
              ></i>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="mt-10px flex justify-around">
          <el-button type="primary" size="small" :disabled="isPlay" @click="addStatus"
            >添加状态</el-button
          >
          <el-button type="primary" size="small" :disabled="isPlay" @click="setStatus"
            >设置状态</el-button
          >
          <el-button type="primary" size="small" :disabled="isPlay" @click="deleteStatus"
            >删除状态</el-button
          >
        </div>
        <div class="mt-10px flex justify-around">
          <el-button
            type="primary"
            v-if="!isPlay"
            size="small"
            class="w-88px"
            @click="previewAnimation"
            >预览</el-button
          >
          <el-button type="primary" v-else size="small" @click="stopPreview">停止预览</el-button>
          <el-button type="primary" size="small" class="w-88px" @click="saveStatusDetails"
            >保存</el-button
          >
          <el-button type="primary" size="small" class="w-88px" @click="cancelSetStatus"
            >取消</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="状态属性"
      :visible.sync="statusAttributeVisible"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :before-close="closeStatusAttribute"
      width="28%"
    >
      <div class="text-white">
        <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
          <el-col :span="2">位置</el-col>
          <el-col :span="1"><span>X</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localTranslation[0]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Y</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localTranslation[1]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Z</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localTranslation[2]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>m</span></el-col>
        </el-row>
        <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
          <el-col :span="2">旋转</el-col>
          <el-col :span="1"><span>X</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localRotation[0]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Y</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localRotation[1]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Z</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localRotation[2]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>°</span></el-col>
        </el-row>
        <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
          <el-col :span="2">比例</el-col>
          <el-col :span="1"><span>X</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localScaling[0]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Y</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localScaling[1]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Z</span></el-col>
          <el-col :span="6"
            ><el-input-number
              v-model="modifyStatusAttribute.localScaling[2]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>%</span></el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveStatusAttribute" size="small">确 定</el-button>
        <el-button @click="closeStatusAttribute" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { AnimationApi } from '@wiz-api/scene-management'
import { isJSONObj, loadAction, EnumObjectTypes } from '../../assets/js/scene/scene'

const animationApi = new AnimationApi()
export default {
  name: 'SceneAnimation',
  props: {
    player: {
      type: Object,
      default: null,
    },
    location: {
      type: Object,
      default: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      default: () => {
        return {
          currentNodeData: {},
        }
      },
    },
  },
  data() {
    return {
      searchKeyword: '',
      nodeList: [],
      showAnimationDetail: false,
      listLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      animationDetail: {
        loopType: 1,
        loopInterval: '',
        speed: 1,
        speedCurve: 0,
      },
      loopTypeOptions: [
        { value: 0, label: '单次' },
        { value: 1, label: '顺序' },
        { value: 2, label: '往复' },
      ],
      speedCurveOptions: [
        { value: 0, label: '匀速' },
        { value: 1, label: '平滑' },
        { value: 2, label: '渐进渐出' },
      ],
      editType: 0,
      currentStatusSeq: 0,
      currentNode: null,
      nodeAnimationDetails: [],
      currentAction: null,
      isPlay: false,
      currentNodeId: null,
      modifyStatusAttribute: {
        localTranslation: [0, 0, 0],
        localRotation: [0, 0, 0],
        localScaling: [0, 0, 0],
      },
      statusAttributeVisible: false,
      selectionIds: [],
      originStatus: {
        localTranslation: [0, 0, 0],
        localRotation: [0, 0, 0, 0],
        localScaling: [1, 1, 1],
      },
    }
  },
  watch: {
    'customProps.deleteNode': {
      handler(val) {
        if (val === this.currentNode) {
          this.currentNode = 0
          this.cancelSetStatus()
        }
      },
    },
  },
  created() {
    this.getNodeList()
  },
  beforeDestroy() {
    this.cancelSetStatus()
  },
  methods: {
    // 保存状态属性
    saveStatusAttribute() {
      const currentIndex = _.findIndex(this.nodeAnimationDetails, ['seqNo', this.currentStatusSeq])
      if (currentIndex !== -1) {
        const quat = EulerAngle.toQuat(this.modifyStatusAttribute.localRotation)
        const statusInfo = {
          localPosition: this.modifyStatusAttribute.localTranslation,
          localRotation: quat,
          localScaling: this.modifyStatusAttribute.localScaling,
        }
        this.player.Native.Node.setProperty(this.currentNode, {
          localTrans: statusInfo.localPosition,
          localRot: quat,
          localScale: statusInfo.localScaling,
        })
        this.$set(this.nodeAnimationDetails[currentIndex], 'properties', JSON.stringify(statusInfo))
        this.closeStatusAttribute()
      }
    },
    // 关闭状态属性
    closeStatusAttribute() {
      this.statusAttributeVisible = false
      this.modifyStatusAttribute = this.$options.data().modifyStatusAttribute
    },
    // 编辑状态
    editCurrentStatus(item) {
      if (this.isPlay) {
        this.$message.warning('动画预览中，无法编辑')
        return
      }
      this.currentStatusSeq = item.seqNo
      this.statusAttributeVisible = true
      const statusInfo = JSON.parse(item.properties)
      this.modifyStatusAttribute.localTranslation = statusInfo.localPosition
      this.modifyStatusAttribute.localRotation = _.map(
        EulerAngle.fromQuat(statusInfo.localRotation),
        (el) => {
          return _.round(el, 2)
        }
      )
      this.modifyStatusAttribute.localScaling = statusInfo.localScaling
    },
    // 设置模型编辑方式
    async setEditType(type) {
      if (this.isPlay) {
        return
      }
      if (!this.currentNode) {
        this.$message.warning('请选择编辑节点')
        return
      }
      if (this.editType === type) {
        this.editType = 0
        await this.player.Native?.Node.setAxisEditType(0)
        return
      }
      this.editType = type
      await this.player.Native?.Node.addNodeToAxisEdit(this.currentNode)
      await this.player.Native?.Node.setAxisEditType(type)
    },
    // 预览动画
    async previewAnimation() {
      this.editType = 0
      await this.player.Native?.Node.setAxisEditType(0)
      if (this.animationDetail.loopType === 0) {
        this.player.Native.AnimationAction.EventActionUpdate.connect(this.watchActionUpdate)
      }
      this.currentAction = await loadAction(
        this.nodeAnimationDetails,
        this.currentNode,
        this.animationDetail,
        this.player
      )
      this.isPlay = true
    },
    // 监听动画
    async watchActionUpdate(data) {
      if (data && data.sender === this.currentAction) {
        if (data.state === 2) {
          await this.player.Native.AnimationAction.EventActionUpdate.disconnect(
            this.watchActionUpdate
          )
          this.stopPreview()
        }
      }
    },
    // 点击状态列表
    handleClickStatus(item) {
      if (this.isPlay) {
        return
      }
      this.currentStatusSeq = item.seqNo
      const statusInfo = JSON.parse(item.properties)
      this.player.Native.Node.setProperty(this.currentNode, {
        localTrans: statusInfo.localPosition,
        localRot: statusInfo.localRotation,
        localScale: statusInfo.localScaling,
      })
    },
    // 取消编辑状态
    async cancelSetStatus() {
      if (this.currentAction) {
        await this.stopPreview()
      } else if (this.nodeAnimationDetails.length) {
        this.player.Native.Node.setProperty(this.currentNode, {
          localTrans: this.originStatus.localPosition,
          localRot: this.originStatus.localRotation,
          localScale: this.originStatus.localScaling,
        })
      }
      this.nodeAnimationDetails = []
      this.editType = 0
      await this.player.Native?.Node.setAxisEditType(0)
      this.currentStatusSeq = null
      this.currentNode = null
      this.showAnimationDetail = false
      this.currentNodeId = null
      this.originStatus = this.$options.data().originStatus
    },
    // 停止预览
    async stopPreview() {
      await this.player.Native.AnimationAction.unbindActionUpdate(this.currentAction)
      await this.player.Native.AnimationAction.stop(this.currentAction)
      this.currentAction = null
      this.isPlay = false
      if (this.nodeAnimationDetails.length && this.currentNode) {
        this.player.Native.Node.setProperty(this.currentNode, {
          localTrans: this.originStatus.localPosition,
          localRot: this.originStatus.localRotation,
          localScale: this.originStatus.localScaling,
        })
      }
    },
    // 获取状态信息
    async getNodeStatus(node) {
      const dataInfo = {}
      const info = await this.player.Native.Node.getProperty(node, [
        'localTrans',
        'localRot',
        'localScale',
      ])
      dataInfo.localPosition = info.localTrans
      dataInfo.localRotation = info.localRot
      dataInfo.localScaling = info.localScale
      return dataInfo
    },
    // 保存
    async saveStatusDetails() {
      const [err, res] = await animationApi.update(this.currentNodeId, {
        body: {
          ...this.animationDetail,
          details: this.nodeAnimationDetails,
        },
      })
      if (!err) {
        this.$message.success('保存成功')
        this.cancelSetStatus()
      }
    },
    // 添加状态
    async addStatus() {
      const statusInfo = await this.getNodeStatus(this.currentNode)
      this.nodeAnimationDetails.push({
        seqNo: this.nodeAnimationDetails.length + 1,
        name: `状态${this.nodeAnimationDetails.length + 1}`,
        properties: JSON.stringify(statusInfo),
      })
      this.$message.success('添加成功')
    },
    // 设置状态
    async setStatus() {
      if (this.currentStatusSeq) {
        const statusInfo = await this.getNodeStatus(this.currentNode)
        const currentIndex = _.findIndex(this.nodeAnimationDetails, [
          'seqNo',
          this.currentStatusSeq,
        ])
        if (currentIndex !== -1) {
          this.$set(
            this.nodeAnimationDetails[currentIndex],
            'properties',
            JSON.stringify(statusInfo)
          )
          this.$message.success('设置成功')
          this.currentStatusSeq = null
        }
      } else {
        this.$message.warning('请选择需要设置的状态')
      }
    },
    // 删除状态
    deleteStatus() {
      if (this.currentStatusSeq) {
        const currentIndex = _.findIndex(this.nodeAnimationDetails, [
          'seqNo',
          this.currentStatusSeq,
        ])
        if (currentIndex !== -1) {
          this.nodeAnimationDetails.splice(currentIndex, 1)
          _.forEach(this.nodeAnimationDetails, (item, index) => {
            this.$set(item, 'seqNo', index + 1)
          })
          this.$message.success('删除成功')
          this.currentStatusSeq = null
        }
      } else {
        this.$message.warning('请选择需要删除的状态')
      }
    },
    // 点击表格
    async handleClickNode(row) {
      if (this.currentNodeId !== row.id) {
        await this.cancelSetStatus()
      }
      this.currentNodeId = row.id
      const [err, res] = await animationApi.get(row.id)
      if (!err) {
        this.nodeAnimationDetails = _.sortBy(res.details, 'seqNo')
        this.animationDetail.loopInterval = res.loopInterval
        this.animationDetail.speed = res.speed
        this.animationDetail.loopType = res.loopType === -1 ? 0 : res.loopType
        this.animationDetail.speedCurve = res.speedCurve === -1 ? 0 : res.speedCurve
        this.showAnimationDetail = true
        const info = await this.player.Native.Node.findNode(0, {
          codes: [row.nodeCode],
        })
        this.currentNode = info?.codes[row.nodeCode]?.node || 0
        if (!this.currentNode) return
        this.originStatus = await this.getNodeStatus(this.currentNode)
        this.player.Native.Camera.moveToNode(this.currentNode, 1)
      }
    },
    // 添加节点
    async addNode() {
      let nodeName = ''
      let nodeCode = ''
      if (
        this.customProps.currentNodeData &&
        isJSONObj(this.customProps.currentNodeData.code) &&
        EnumObjectTypes.includes(JSON.parse(this.customProps.currentNodeData.code).type)
      ) {
        nodeName = this.customProps.currentNodeData.name
        nodeCode = this.customProps.currentNodeData.code
      }
      if (nodeCode && nodeName) {
        const [err, res] = await animationApi.create({
          body: {
            nodeName,
            nodeCode,
            sceneId: this.$route.query.sceneId,
            seqNo: 1,
          },
        })
        if (!err) {
          this.$message.success('加入成功')
          this.getNodeList()
        }
      } else {
        this.$message.warning('请选择正确的节点！')
      }
    },
    // 获取搜索结果
    getSearchResult() {
      this.page.pageNo = 1
      this.getNodeList()
    },
    // 获取节点数据
    async getNodeList() {
      this.listLoading = true
      const [err, res] = await animationApi.getList({
        sceneId: this.$route.query.sceneId,
        keyWord: this.searchKeyword,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.listLoading = false
      if (!err) {
        this.nodeList = res.items
        this.page.pageTotal = res.totalCount
      }
    },
    // 删除数据
    deleteData() {
      this.$confirm('是否确认删除所选数据？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await animationApi.deleteMany({ ids: this.selectionIds })
        if (!err) {
          this.$message.success('删除成功')
          this.$refs.nodeTable.clearSelection()
          this.cancelSetStatus()
          this.page.pageNo = 1
          this.getNodeList()
          this.selectionIds = []
        }
      })
    },
    // 选中表格
    selectionChange(columns) {
      this.selectionIds = _.map(columns, 'id')
    },
    closeComponent() {
      this.$emit('closeComponent', 'SceneAnimation')
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/style/select';
</style>
<style lang="scss" scoped>
@import '../../assets/style/index';

.sceneAnimation {
  background-color: rgba(0, 18, 55, 0.3) !important;
}

.content {
  background: rgba(16, 27, 47, 0.4);
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
</style>
